"use client";

import { Footer } from "@/components/footer";
import { Sdwan } from "@/components/page/sdwan/sdwan";
import { SdwanProposal } from "@/components/page/sdwan/proposal";
import { GlobalNetwork } from "@/components/page/sdwan/globalNetwork";
import { Why } from "@/components/page/sdwan/why";
import { Scene } from "@/components/page/sdwan/scene";
import { AutofitPageWrapper } from "@/components/AutofitPageWrapper";
import { useIsMobile } from "@/app/hooks/useIsMobile";
import { SdwanMobileFirst } from "@/components/page/sdwan-mobile/first";
import { MobileFooter } from "@/components/mobile-footer";
import { HeaderMobile } from "@/components/header-mobile";
import { SdwanMobileSecond } from "@/components/page/sdwan-mobile/second";
import { SdwanMobileThree } from "@/components/page/sdwan-mobile/three";
import { SdwanMobileFourth } from "@/components/page/sdwan-mobile/fourth";
import { SdwanMobileFive } from "@/components/page/sdwan-mobile/five";


export default function SdwanPageClient() {
  const isMobile = useIsMobile();

  if (isMobile === null)
    return (
      <div
        className="w-screen h-screen"
        style={{ background: "linear-gradient(135deg, rgba(236,245,255,1) 2.885%, rgba(157,168,255,1) 56.731%, rgba(144,201,255,1) 97.596%)" }}
      />
    );

  if (isMobile) {
    return (
      <div className="flex flex-col w-full h-screen overflow-y-auto">
        <HeaderMobile />
        <SdwanMobileFirst />
        <SdwanMobileSecond />
        <SdwanMobileThree />
        <SdwanMobileFourth />
        <SdwanMobileFive />
        <MobileFooter />
      </div>
    );
  }

  return (
    <AutofitPageWrapper>
      <Sdwan />
      <SdwanProposal />
      <GlobalNetwork />
      <Why />
      <Scene />
      <Footer />
    </AutofitPageWrapper>
  );
}

